/**
 * Farbwelten für die Ballons.
 *
 * Das ist das einzige Belohnungssystem der App, und es ist mit Absicht keine
 * Währung. Es gibt keine Punkte, für die man sich etwas kauft, sondern
 * Farbwelten, die sich öffnen, weil tatsächlich mehr Aufgaben sitzen. Damit
 * belegt die Freischaltung etwas Wahres ("du kannst jetzt 20 Aufgaben sicher")
 * statt nur Fleiß zu vergüten.
 *
 * Der zweite Teil ist genauso wichtig: Freigeschaltet heißt nicht aufgezwungen.
 * Lina wählt aus, womit sie spielen will, und darf auch bei ihrer ersten
 * Farbwelt bleiben. Diese Wahlmöglichkeit ist der eigentliche Wirkstoff,
 * nicht das Freischalten.
 */

export interface Ballonset {
  id: string
  name: string
  /** Wie viele Karten sicher sitzen müssen (Fach 4 oder höher). */
  abSicher: number
  /** Vier Farben, eine je Ballon. */
  farben: [string, string, string, string]
  /** Farbe der Zahl auf dem Ballon. Muss auf allen vier Farben lesbar sein. */
  schrift: string
}

export const BALLONSETS: Ballonset[] = [
  {
    id: 'abendhimmel',
    name: 'Abendhimmel',
    abSicher: 0,
    farben: ['#ef476f', '#ffd166', '#06d6a0', '#4cc9f0'],
    schrift: '#2b1a00',
  },
  {
    id: 'bonbon',
    name: 'Bonbon',
    abSicher: 5,
    farben: ['#ff8fab', '#ffc2d1', '#c77dff', '#80ffdb'],
    schrift: '#3d1029',
  },
  {
    id: 'dschungel',
    name: 'Dschungel',
    abSicher: 12,
    farben: ['#70e000', '#38b000', '#9ef01a', '#ccff33'],
    schrift: '#1a3300',
  },
  {
    id: 'meer',
    name: 'Tiefsee',
    abSicher: 20,
    farben: ['#48cae4', '#00b4d8', '#90e0ef', '#ade8f4'],
    schrift: '#03203a',
  },
  {
    id: 'sonnenaufgang',
    name: 'Sonnenaufgang',
    abSicher: 30,
    farben: ['#ff7b00', '#ffa200', '#ffc300', '#ffdd00'],
    schrift: '#40200a',
  },
  {
    id: 'einhorn',
    name: 'Einhorn',
    abSicher: 42,
    farben: ['#f72585', '#b5179e', '#7209b7', '#4cc9f0'],
    schrift: '#ffffff',
  },
]

export function ballonsetFuer(id: string | null | undefined): Ballonset {
  return BALLONSETS.find((s) => s.id === id) ?? BALLONSETS[0]!
}

export function freigeschalteteSets(anzahlSicher: number): Ballonset[] {
  return BALLONSETS.filter((s) => anzahlSicher >= s.abSicher)
}

/**
 * Das Set, das als nächstes dazukommt, und wie viele Karten noch fehlen.
 *
 * Wird nach einer Runde angezeigt, wenn es nah genug ist. Ein Ziel, das noch
 * dreißig Karten entfernt liegt, motiviert niemanden; eines, das noch zwei
 * entfernt ist, sehr.
 */
export function naechstesSet(
  anzahlSicher: number,
): { set: Ballonset; nochKarten: number } | null {
  const offen = BALLONSETS.find((s) => anzahlSicher < s.abSicher)
  if (!offen) return null
  return { set: offen, nochKarten: offen.abSicher - anzahlSicher }
}
